import React, { useState } from 'react';
import { useField } from 'formik';
import EditorWYSIWYG from '../EditorWYSIWYG';
import Select from 'react-select';

export const SelectBoxWithSearch = ({ label, options, ...props }) => {
  const [field, meta, helpers] = useField(props.name);
  const { setValue } = helpers;

  const selectedOption =
    options?.find((opt) => opt.value === field.value) || null;

  return (
    <div className='form-group'>
      <label htmlFor={props.name}>{label}</label>
      <Select
        inputId={props.name}
        options={options}
        value={selectedOption}
        onChange={(option) => {
          console.log('Selected option:', option);
          setValue(option?.value || '');

          if (props.onChange) {
            // Simulate a synthetic event for compatibility
            props.onChange({ target: { value: option?.value || '' } });
          }
        }}
        classNamePrefix='react-select'
        placeholder='Select...'
      />
      {meta.touched && meta.error && (
        <div className='text-danger'>{meta.error}</div>
      )}
    </div>
  );
};

export const SelectBox = ({ label, ...props }) => {
  const [field, meta] = useField(props);
  return (
    <div className='form-group'>
      <label htmlFor={props.id || props.name}>{label}</label>
      <select
        id={props.name}
        className='form-control custom-select'
        {...field}
        {...props}
      />
      {meta.error ? <div className='text-danger'>{meta.error}</div> : null}
    </div>
  );
};

export const TextInput = ({ label, ...props }) => {
  const [field, meta] = useField(props);
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = props.type === 'password';
  return (
    <div className='form-group' style={{ position: 'relative' }}>
      <label htmlFor={props.id || props.name}>{label}</label>
      <input
        id={props.name}
        className='form-control'
        name={props.name}
        value={field.value}
        onChange={field.onChange}
        onBlur={field.onBlur}
        type={isPassword && showPassword ? 'text' : props.type}
        autoComplete={isPassword ? 'current-password' : undefined}
        placeholder={props.placeholder}
      />
      {isPassword && (
        <span
          onClick={() => setShowPassword((v) => !v)}
          style={{
            position: 'absolute',
            right: 12,
            top: 38,
            cursor: 'pointer',
            zIndex: 2,
            color: '#888',
          }}
          title={showPassword ? 'Hide Password' : 'Show Password'}
        >
          <i className={`fa ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
        </span>
      )}
      {meta.error ? <div className='text-danger'>{meta.error}</div> : null}
    </div>
  );
};
export const HTMLInput = ({ label, ...props }) => {
  // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
  // which we can spread on <input> and also replace ErrorMessage entirely.
  const [field, meta] = useField(props);
  console.log('Meta', meta);
  return (
    <div className='form-group'>
      <label htmlFor={props.id || props.name}>{label}</label>

      <EditorWYSIWYG
        id={props.name}
        {...props}
        changeValue={(value) => {
          props.setFieldValue(props.name, value);
          // props.setFieldValue(`${item}[${fieldIndex}][${single_value}]`, value);
        }}
      />
      {meta.error ? <div className='text-danger'>{meta.error}</div> : null}
    </div>
  );
};

export const TextInputHorizontal = ({ label, ...props }) => {
  // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
  // which we can spread on <input> and also replace ErrorMessage entirely.
  const [field, meta] = useField(props);
  return (
    <div className='form-group'>
      <div className='col-md-2'>
        <label htmlFor={props.id || props.name}>{label}</label>
      </div>
      <div className='col-md-10'>
        <input className='form-control' {...field} {...props} />
        {meta.touched && meta.error ? (
          <div className='text-danger'>{meta.error}</div>
        ) : null}
      </div>
    </div>
  );
};

export const TextArea = ({ label, ...props }) => {
  // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
  // which we can spread on <input> and also replace ErrorMessage entirely.
  const [field, meta] = useField(props);
  return (
    <div className='form-group'>
      <label htmlFor={props.id || props.name}>{label}</label>
      <textarea
        id={props.name}
        className='form-control'
        {...field}
        {...props}
      />
      {meta.touched && meta.error ? (
        <div className='text-danger'>{meta.error}</div>
      ) : null}
    </div>
  );
};
export const RadioButton = ({ label, ...props }) => {
  // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
  // which we can spread on <input> and also replace ErrorMessage entirely.
  const [field, meta] = useField(props);
  return (
    <>
      <input type='radio' className='form-check-input' {...field} {...props} />
      <label htmlFor={props.id || props.name}>{label}</label>
      {meta.touched && meta.error ? (
        <div className='text-danger'>{meta.error}</div>
      ) : null}
    </>
  );
};

export const CheckBox = ({ children, ...props }) => {
  // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
  // which we can spread on <input> and also replace ErrorMessage entirely.
  const [field, meta] = useField({ ...props, type: 'checkbox' });
  return (
    <div className='form-group'>
      <div className='pt-3'>
        <label className='checkbox'>
          <input type='checkbox' {...field} {...props} />
          {'  '} {children}
        </label>
        {meta.touched && meta.error ? (
          <div className='error'>{meta.error}</div>
        ) : null}
      </div>
    </div>
  );
};
